// Styles
import './QrCode.scss';

// Libs
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from 'rsuite';

// Components
import Button from '@/common/components/atoms/Button/Button';
// Assets
import { ReactComponent as QrCodeIcon } from '@/ebat/assets/icons/qr-code.svg';

// PropTypes
import { QrCodeDefaultProps, QrCodePropTypes } from './QrCode.proptypes';

const QrCode = ({ isOpen, onScanQrCode }) => {
  const { t } = useTranslation();

  return (
    <Modal className="modal-qr-code" data-qa-id="modal-qr-code" open={isOpen}>
      <p className="modal-qr-code__surtitle">
        {t('ebat:entities:scanbat.login.qr_code.surtitle')}
      </p>
      <h1 className="rs-modal-title">
        {t('ebat:entities:scanbat.login.qr_code.title')}
      </h1>
      <Button className="modal-qr-code__button" onClick={onScanQrCode}>
        <QrCodeIcon className="icon" />
      </Button>
    </Modal>
  );
};

QrCode.defaultProps = {
  ...QrCodeDefaultProps,
};

QrCode.propTypes = {
  ...QrCodePropTypes,
};

export default QrCode;
